export default __webpack_public_path__ + "locales/ko-KR/InviteDialog.json?hash=42ab39fb9412970530a282a3e3cec699";